import { render } from "./ProductImages.vue?vue&type=template&id=2e438412"
import script from "./ProductImages.vue?vue&type=script&lang=ts"
export * from "./ProductImages.vue?vue&type=script&lang=ts"

import "./ProductImages.vue?vue&type=style&index=0&id=2e438412&lang=scss"
script.render = render

export default script